import api from '@/plugins/api'
import Tinymce from 'tinymce/tinymce'
import 'tinymce/icons/default'
import 'tinymce/plugins/media'
import 'tinymce/themes/silver'
import 'tinymce/plugins/link'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/image'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/code'
import lang, { getUserLang } from '@/plugins/lang'
import { Swal } from '@/plugins/sweetalert2'
import * as pageLoading from '@/components/page-loading'

// import 'tinymce/plugins/quickbars'
// import 'tinymce/plugins/autoresize'
// import 'tinymce/plugins/wordcount'

let userLang = getUserLang()

let langFile = null

if (userLang && userLang !== 'en') {
    userLang = userLang.replace('-', '_')

    langFile = `/js/lang/tinymce/${userLang}.js`
}

function showAlertImagePasted(content) {
    if (content.slice(1,4) === 'img') {
        Swal.fire({
            title: lang.t('alert:tinymce_paste_image_title'),
            text: lang.t('alert:tinymce_paste_image_text'),
            icon: 'warning',
        });
    }
}

function uploadImage(resource, blobInfo, success, failure, progress) {
    const formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());

    progress(0);

    api(`/files/${resource}/tmp`, { body: formData, method: 'POST', ignoreCode: '*' })
        .then(data => {
            const fileUrl = `${window.location.origin}/files/tmp/${data}`
            success(fileUrl)
        })
        .catch(error => {
            console.error("❌ Erro ao enviar:", error)
            failure(error.data ? error.data.message : "Erro desconhecido")
        })
}

class UploadImageError extends Error {
    constructor() {
        super('Error uploading image to the server')
        this.code = 'error-upload-image'
    }
}

export default {
    async buildTextEditor(selector, options = {}) {
        await pageLoading.startLoading()

        let response = await Tinymce.init({
            selector,
            skin: false,
            language: userLang,
            language_url: langFile,
            content_css: '/css/tinymce.css',
            height: '480',
            plugins: 'link table lists advlist paste autolink code',
            toolbar: 'undo redo | bold italic | indent outdent | bullist numlist | code',
            menubar: 'edit insert table',
            paste_as_text: true,
            paste_preprocess: function(plugin, args) {
                showAlertImagePasted(args.content)
            },
            ...options,
        })

        pageLoading.doneLoading()

        return response.length === 1 ? response[0] : response
    },

    /**
     * @param selector
     * @param {string} resource
     * @param options
     * @return {Promise<Editor|Editor[]>}
     */
    buildImageTextEditor(selector, resource, options = {}) {
        return this.buildTextEditor(selector, {
            plugins: 'link table lists advlist paste imagetools autolink image code',
            toolbar: 'undo redo | bold italic | indent outdent | bullist numlist | code',
            file_picker_types: 'image',
            automatic_uploads: true,
            relative_urls : false,
            image_advtab: false,
            image_title: true,
            image_description: false,
            paste_data_images: false,
            images_upload_handler: (blobInfo, success, failure, progress) => uploadImage(resource, blobInfo, success, failure, progress),
            ...options,
            setup: (editor) => {
                    editor.on("OpenWindow", function() {
                        const editorTabs = document.querySelectorAll(".tox-dialog__body-nav-item.tox-tab")
                        if(editorTabs.length === 2) {
                            const [generalTab, uploadTab] = editorTabs

                            generalTab.style.display = "none"
                            
                            uploadTab?.click()
                        }
                    })
              }
        })
    },

    /**
     * @param {Editor} editor
     * @param {FormData} formData
     * @return {Promise<FormData>}
     */
    async saveToFormData(editor, formData) {
        const result = await editor.uploadImages()

        for (let upload of result) {
            if (!upload.status) {
                Swal.fire({
                    title: lang.t('alert:tinymce_image_upload.title'),
                    text: lang.t('alert:tinymce_image_upload.text'),
                    icon: 'warning',
                })

                throw new UploadImageError()
            }
        }

        formData.set(editor.targetElm.name, editor.save())

        return formData
    },
}

